import { render, staticRenderFns } from "./e-iframe-page.vue?vue&type=template&id=d3476d18&scoped=true"
import script from "./e-iframe-page.vue?vue&type=script&lang=js"
export * from "./e-iframe-page.vue?vue&type=script&lang=js"
import style0 from "./e-iframe-page.vue?vue&type=style&index=0&id=d3476d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3476d18",
  null
  
)

export default component.exports